import React, { useState } from "react";
import { MultilineTitle } from "../../molecules";
import { Logo, Title, UnderlineText } from "../../atoms";
import { MobileMenu } from "../MobileMenu/MobileMenu";
import { FaBars } from "react-icons/fa";
import { AnalyticsService } from "../../../utils/Analytics";
import {GETUSERS,VIEWASUSER } from "../../../api/apiConfig";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useEffect } from "react";
import { Button, Grid, Stack } from "@mui/material";
import { apiGet, apiPost } from "../../../utils";
import Select from "react-select";
import Modal from "react-responsive-modal";
import { RxDropdownMenu } from "react-icons/rx";
import { IoMdArrowDropdown } from "react-icons/io";


export const AppHeader = ({ upperText, bottomText, linkText, Signout }) => {
  const [menu, setMenu] = useState(false);
  const [xSwitch, setXSwitch] = useState({value:"1",label:localStorage.getItem("xSwitch")});
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [time, setTime] = useState(moment().format("h:mm a"));
  const [isAdmin,setIsAdmin] =useState(localStorage.getItem("roleId")=="1")
  const [increaseHeight,setIncreaseHeight]=useState(false)
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const openMenu = () => {
    setMenu(true);
    AnalyticsService.logEvent("MOBILE_MENU_OPEN");
  };
  const onClose = () => {
    setMenu(false);
    AnalyticsService.logEvent("MOBILE_MENU_CLOSE");
  };
    useEffect(() => {
      isAdmin && users.length==0 && getUserList();
        setInterval(() => {
          setTime(moment().format("h:mm a"));
        }, 1000);
    
        return () => {
          setTime("");
        };
      
      }, []);

  const userList =
  users &&
  users.map((m) => ({
    value: m.id,
    label: m.name,
  }));
  
  
  const getUserList = async () => {
    const res = await apiGet(GETUSERS);
    if (res) {
      setUsers(res)
      var user=res.filter(x=>x.id==localStorage.getItem("id"))[0]
      setXSwitch({value:"1",label:user?.xSwitch});
      localStorage.setItem("xSwitch", user?.xSwitch);
      setIsAdmin(user.role==1);
    }
  };

  function SelectUser(){
    const action = async () => {
      
      const res = await apiPost(`${VIEWASUSER}`, {Name: xSwitch?.label});
      if (res) {
        AnalyticsService.logEvent("User_Chosen");
        localStorage.setItem("xSwitch", xSwitch?.label);
        setOpen(false)
        window.location.reload();
      }
    };    
    return (
      <Modal style={{width:'unset'}} open={open} showCloseIcon={true} center onClose={onCloseModal}>
        <div className="padding">
          <div className="bold lg space-bottom2">Select Merchant</div>
          <div className="sm space-bottom2">Please select the merchant you want to open as</div>
          <Grid container spacing={2} style={{minHeight:increaseHeight?"380px":"auto",width:'100%'}}>
              <Grid item xs={12} id="categorySelection" style={{width:'100%'}} >
          <Select
          
            onMenuOpen={()=>setIncreaseHeight(true)}
            onMenuClose={()=>setIncreaseHeight(false)}
            placeholder={"Please select"}
            onChange={(option) => setXSwitch(option)}            
            options={userList}
            value={xSwitch}
            defaultValue={userList ? userList[0] : undefined}
            isSearchable={true}
          />
          </Grid>
          </Grid>

          <div className="push-right space-top">
            <Stack direction={"row"} spacing={2}>
              <Button variant="contained" sx={{background:"#000"}} onClick={()=>setOpen(false)}>Close</Button>
              <Button variant="contained" sx={{background:"#4E9D24"}} onClick={()=>action()}>Proceed</Button>
            </Stack>

          </div>
        </div>
      
      </Modal>
    )
  }

  return (
    <>
      {isAdmin && SelectUser()}
      {!menu ? <div className="appHeaderSec">
        <div className="logo-and-title nowrap space-right2">
          <div onClick={openMenu}>
            <FaBars className="menuIcon" />
          </div>
          <img src={require('../../../assets/images/logo2.png')} className={"header-logo"} alt="Logo image" />
          
          <div className={`multiSec leftHeader `} >
              <Stack direction={"row"} spacing={2} className="center">
                {(xSwitch?.label==null || !isAdmin) &&
                  <Title className={"headerTxtUprLeft nowrap"} text={upperText} />
                }
                {(isAdmin) &&
                (
                <span onClick={()=>isAdmin && setOpen(true)} className="blue headerTxtUprLeft nowrap ruby center click">
                  {/* <img src={require('../../../assets/images/down.png')} width={15} height={20}  alt="Logo image" style={{marginRight:'5px'}} /> */}
                  ⬇️
                  {xSwitch?.label} 
                </span>
                )}
              </Stack>
              <Title className={"headerTxtBtmLeft nowrap"} text={bottomText} />
          </div>
          
        
        </div>
        {!isTabletOrMobile &&
        
      <Stack spacing={0.5} style={{width:'100%',opacity:'.5'}}>
        <hr style={{borderTop:"dashed 2px #E3031F",borderBottom:'none',marginBottom:'-0.5px'}}/>
        <hr style={{borderTop:"solid 2px #E3031F",borderBottom:'none'}}/>
        <hr style={{borderBottom:"dashed 2px #E3031F",borderTop:'none'}}/>
      </Stack>}
      {!isTabletOrMobile &&
        <div className="underlinetext-div">
        <div className={`multiSec headerBoxRight`}>
            <Title className={"headerTxt nowrap"} text={moment().format("Do MMM YYYY")} />
            <Title className={"headerTxt nowrap"} text={time} />
        </div>
        </div>
      }
      </div> : null}
        {menu ?  (
          <MobileMenu
            position={"left"}
            isVisible={menu}
            onMenuClose={onClose}
            onVisibleChange={onClose}
          />
        ) : null}
    </>
  );
};
